import clsx from "clsx";

interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const LinkedinIcon: React.FC<IconProps> = ({ className, theme= 'dark' }) => {
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 12"
      className={clsx(className, 'w-[1.2rem] h-[1.2rem]')}
    >
      <path
        fill={theme === 'light' ? '#FF77A8' : '#131313'}
        d="M3.3164 1.3371A1.3333 1.3333 0 1 1 .65 1.3358a1.3333 1.3333 0 0 1 2.6665.0013Zm.04 2.3199H.69v8.3462h2.6665V3.657Zm4.2131 0H4.9163v8.3462h2.6265V7.6234c0-2.4398 3.1799-2.6665 3.1799 0v4.3798h2.6332V6.7168c0-4.1131-4.7064-3.9598-5.813-1.9399l.0266-1.12Z"
      />
    </svg>
  );
}